(function Processor($, Adzuki)
{
	"use strict";

	// var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload([
			/^CruiseBooking\//,
			'Reservations/addTravelVendorDetails',
			'Reservations/manage',
			'Reservations/manageComponents',
			'Reservations/managePayments',
			'Reservations/submitPaymentToCruiseLine',
		], function onload() {
			setTimeout(function timeout() {
				var $cruise_booking_issue = $('.cruise-booking-issue');

				$cruise_booking_issue.find('.report-issue-button').on('click', function click(e) {
					$cruise_booking_issue.find('.step-1').addClass('hidden');
					$cruise_booking_issue.find('.step-2').removeClass('hidden');
				});

				$cruise_booking_issue.find('.report-issue-form').on('submit', function submit(e) {
					var data = new FormData(this);

					e.preventDefault();

					$cruise_booking_issue.find('.step-2').addClass('hidden');
					$cruise_booking_issue.find('.step-3').removeClass('hidden');

					$.ajax({
						url        : Adzuki.base_uri + '/CruiseBooking/reportIssue',
						type       : 'POST',
						data       : data,
						processData: false,
						contentType: false,
						success    : function success(response) {
							$cruise_booking_issue.find('.step-3').addClass('hidden');
							$cruise_booking_issue.find('.step-4').removeClass('hidden');
						},
					});
				});
			}, 500);

			// $('.synch-now').click(function showEconnectSync(e) {
			// 	var $self                 = $(this),
			// 	    component_id          = $self.data('id'),
			// 	    reservation_vendor_id = $self.data('vendor-id'),
			// 	    payment               = ((typeof $self.data('payment') === 'undefined') ? '0' : '1');

			// 	e.preventDefault();

			// 	Adzuki.Ajax.get('/CruiseBooking/sync')
			// 		.then(function _showSync(html) {
			// 			$modal.find('.modal-body').html(html);
			// 			$modal.find('[data-toggle^="tooltip"]').tooltip();
			// 	});

			// 	Adzuki.Ajax.get('/CruiseBooking/syncBooking/' + component_id + '/' + payment)
			// 		.then(function _syncBooking(response) {
			// 			if (response.return_value === 'matchPassengers') {
			// 				window.location.href = Adzuki.base_uri + '/CruiseBooking/matchPassengers';
			// 			} else if (response.return_value === 'editTravelPricing') {
			// 				window.location.href = Adzuki.base_uri + '/Reservations/editTravelPricing/' + reservation_vendor_id + '/' + payment;
			// 			} else if (response.return_value === 'submitPaymentToCruiseLine') {
			// 				window.location.href = Adzuki.base_uri + '/Reservations/submitPaymentToCruiseLine/' + reservation_vendor_id;
			// 			} else {
			// 				location.reload();
			// 			}
			// 	});

			// 	$modal.find('.modal-title').text("Synchronizing Booking");
			// 	$('.modal-footer').addClass('hidden');

			// 	$modal.on('hidden.bs.modal', function _restoreModal() {
			// 		$('.modal-footer').removeClass('hidden');
			// 	}).modal({
			// 		backdrop: 'static',
			// 		keyboard: false,
			// 	});
			// });
		}, false);
	});

}(jQuery, window.Adzuki || {}));